<template>
  <div class="full_page">
    <h3>AR Notes Log</h3>
    <table class="table table-striped table-bordered table-hover table-condensed align_left">
      <thead>
      <tr>
        <th>Date Time</th>
        <th>Notes</th>
        <th>Dispensary</th>
      </tr>
      </thead>
      <tbody class="align_left">
      <tr v-for="notes in account_receivables_notes_log" v-bind:key="notes.create_date">
        <td style="white-space:nowrap;">{{notes.create_date}}</td>
        <td>{{notes.notes}}</td>
        <td style="white-space:nowrap;">{{notes.display_name_order}} ({{notes.customer_id}})</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      account_receivables_notes_log: 'admin/account_receivables_notes_log',
      account_receivables_notes_log_loading: 'admin/account_receivables_notes_log_loading',
    }),
  },
  watch: {
  },
  mounted() {
    this.get_ar_notes_log();
  },
  methods: {
    get_ar_notes_log() {
      this.$store.dispatch('admin/getAccountReceivablesNotesLog', {type: '0'});
    },
  }
}
</script>


<style scoped>

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

.align_left {
  text-align: left;
}

</style>

